import { Component } from "react";
import { Button, Layout, message, Space, Tree } from "antd";

import NavHeader from "../../components/NavHeader";
import SiderMenuMain from "../../components/SiderMenuMain";
import NavFooter from "../../components/NavFooter";

// import '../css/main.less'
import React from "react";
import ReactDOM from "react-dom";
import AxiosUtil from "../../utils/AxiosUtil";
import NavBreadcrumb from "../../components/NavBreadcrumb";
import EditableTable from "../../components/EditableTable";
import moment from "moment";
import { SortAscendingOutlined, StopOutlined } from "@ant-design/icons";
import { FunctionProps } from "./model/function";

const { Content } = Layout;
interface IProps {}

export default class Function extends Component<IProps> {
  state = {
    parents: [0],
    mainData: [],
    sorting: false,
  };

  componentDidMount() {
    this.reload();
  }

  reload = () => {
    AxiosUtil.AxiosRequest("/api/function/list", {}, this.loadMainData);
  };

  render() {
    const crumb = [{ name: "系统管理" }, { name: "功能菜单" }];
    return (
      <Layout>
        <NavHeader />
        <Content className={"main-body"}>
          <Layout>
            <SiderMenuMain />
            <Content className={"main-content"}>
              <NavBreadcrumb itemList={crumb} />

              <div id="mainTable" hidden={this.state.sorting}></div>
              <div id="mainTree" hidden={!this.state.sorting}>
                <Space size={16} style={{ marginBottom: 16 }}>
                  <Button type="primary" onClick={this.saveSort}>
                    <SortAscendingOutlined /> 保存排序
                  </Button>
                  <Button onClick={this.cancelSort}>
                    <StopOutlined /> 取消
                  </Button>
                </Space>

                <Tree
                  key={moment().format("X")}
                  className="draggable-tree"
                  defaultExpandAll={true}
                  draggable
                  blockNode
                  // showIcon
                  onDragEnter={this.onDragEnter}
                  onDrop={this.onDrop}
                  treeData={this.state.mainData}
                />
              </div>
            </Content>
          </Layout>
        </Content>
        <NavFooter />
      </Layout>
    );
  }

  onDragEnter = (info: any) => {
    console.log("onDragEnter", info);
    // expandedKeys 需要受控时设置
    // this.setState({
    //   expandedKeys: info.expandedKeys,
    // });
  };

  onDrop = (info: any) => {
    console.log("onDrop", info);
    const dropKey = info.node.key;
    const dragKey = info.dragNode.key;
    const dropPos = info.node.pos.split("-");
    const dropPosition =
      info.dropPosition - Number(dropPos[dropPos.length - 1]);

    const loop = (data: any, key: any, callback: any) => {
      for (let i = 0; i < data.length; i++) {
        if (data[i].key === key) {
          return callback(data[i], i, data);
        }
        if (data[i].children) {
          loop(data[i].children, key, callback);
        }
      }
    };
    const data = [...this.state.mainData];

    // Find dragObject
    let dragObj: any;
    loop(data, dragKey, (item: any, index: any, arr: any[]) => {
      arr.splice(index, 1);
      dragObj = item;
    });

    if (!info.dropToGap) {
      // Drop on the content
      loop(data, dropKey, (item: { children: any[] }) => {
        item.children = item.children || [];
        // where to insert 示例添加到头部，可以是随意位置
        item.children.unshift(dragObj);
      });
    } else if (
      (info.node.props.children || []).length > 0 && // Has children
      info.node.props.expanded && // Is expanded
      dropPosition === 1 // On the bottom gap
    ) {
      loop(data, dropKey, (item: { children: any[] }) => {
        item.children = item.children || [];
        // where to insert 示例添加到头部，可以是随意位置
        item.children.unshift(dragObj);
        // in previous version, we use item.children.push(dragObj) to insert the
        // item to the tail of the children
      });
    } else {
      let ar: any[] = [];
      let i = 0;
      loop(data, dropKey, (item: any, index: any, arr: any) => {
        ar = arr;
        i = index;
      });
      if (dropPosition === -1) {
        ar.splice(i, 0, dragObj);
      } else {
        ar.splice(i + 1, 0, dragObj);
      }
    }

    this.setState({
      mainData: data,
    });
  };

  openSort = () => {
    this.setState({ sorting: true });
  };
  cancelSort = () => {
    this.setState({ sorting: false });
  };
  saveSort = () => {
    console.log("saveSort", this.state.mainData);
    let saveData: any[] = [];
    let sidx = 1;
    const getSortedData = (d: any[], p?: number) => {
      d.forEach((v: any) => {
        saveData.push({
          ...v,
          sort_index: sidx,
          children: null,
          parent_id: p || null,
        });
        sidx++;
        if (v.children && v.children.length > 0) {
          getSortedData(v.children, v.function_id);
        }
      });
    };
    getSortedData([...this.state.mainData]);
    console.log("saveSorted", saveData);
    const callback = (suc: boolean, dat: any) => {
      if (suc) {
        message.success({
          content: "排序保存成功！",
          className: "message_success",
        });
        this.reload();
      }
    };
    AxiosUtil.AxiosRequest("/api/function/grid", { list: saveData }, callback);
  };
  saveRecord = (record: any) => {
    console.log("save:", record);
    const callback = (suc: boolean, dat: any) => {
      if (suc) {
        console.log(suc, dat);
        message.success({
          content: "保存成功！",
          className: "message_success",
        });
        this.reload();
      }
    };
    AxiosUtil.AxiosRequest("/api/function/grid", { list: [record] }, callback);
  };
  deleteRecord = (record_key: string) => {
    const callback = (suc: boolean, dat: any) => {
      if (suc) {
        console.log(suc, dat);
        message.success({
          content: "记录已删除成功！",
          className: "message_success",
        });
      }
    };
    AxiosUtil.AxiosRequest(
      "/api/function/grid",
      { list: [{ function_id: record_key, isDelete: 1 }] },
      callback
    );
  };
  loadMainData = (suc: boolean, dat: any) => {
    if (suc) {
      const cleanData = (data: FunctionProps[]) => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children && data[i].children!.length === 0) {
            data[i].children = undefined;
          } else if (data[i].children && data[i].children!.length > 0) {
            data[i].children = cleanData(data[i].children!);
          }
          data[i].title = data[i].function_name;
          data[i].key = data[i].function_id;
          // data[i].icon= <MenuOutlined className='grey' />;
        }
        return data;
      };
      let myData = cleanData(dat);
      this.setState({ mainData: myData });

      const columns = [
        {
          title: "ID",
          key: "function_id",
          dataIndex: "function_id",
          width: 60,
          align: "center" as "center",
        },
        {
          title: "功能菜单",
          key: "function_name",
          dataIndex: "function_name",
          editor: { type: "text", required: true },
        },
        {
          title: "页面链接",
          key: "page_url",
          dataIndex: "page_url",
          editor: { type: "text", required: true },
        },
        {
          title: "展示图标",
          key: "icon",
          dataIndex: "icon",
          editor: { type: "text" },
        },
        {
          title: "类型",
          key: "function_type",
          width: 80,
          dataIndex: "function_type",
          align: "center" as "center",
          editor: { type: "number", required: true },
        },
      ];

      const sortButton = [
        <Button
          type="primary"
          key="Kx"
          onClick={this.openSort}
          hidden={this.state.sorting}
        >
          <SortAscendingOutlined /> 排序
        </Button>,
      ];

      ReactDOM.render(
        <EditableTable
          key={moment().format("X")}
          columns={columns}
          datas={this.state.mainData}
          record_key="function_id"
          saveCallback={this.saveRecord}
          deleteCallback={this.deleteRecord}
          reloadCallback={this.reload}
          addChild={true}
          exButtons={sortButton}
        />,
        document.getElementById("mainTable")
      );
    }
  };
}
